import React, { useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import f500Logo from '../images/F500-Logo.jpg';
import fortuneLogo from '../images/Fortune-WMAC-2025.jpg';
import topWorkplaceLogo from '../images/topWorkplaces2025.jpg';
import forbesMostTrustedLogo from '../images/MostTrustedCompaniesInAmerica-01.jpg';
import forbesBestCompaniesLogo from '../images/AmericasBestCompanies_2025.jpg';
import vetsIndex2025Logo from '../images/awards-2025-4star.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import './Pages.css';

export default function FY22AwardsAndRecognition() {
  localStorage.setItem('activeLinkIndex', '3');
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  const navigate = useNavigate(); // Example of commented-out code

  return (
    <>
    <div className='main-container'>
      <Container>
        <div className='contentArea flex'>
          {/* Header */}
          <Row className='headerRow'>
            <h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>
              FY 2025 Awards and recognitions
            </h1>
          </Row>
          <hr/>
          <Row className='gx-5 text-center noScrollRow' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>
            <Col lg={4} md={6} xs={6} className='mt-lg-0 mt-5'>
              <img alt='Fortune 500 logo' className='awardLogo' src={f500Logo} />
            </Col>
            <Col lg={4} md={6} xs={6} className='mt-lg-0 mt-5'>
              <img alt='Fortune 2025: Worldss Most Admired Companies logo' className='awardLogo' src={fortuneLogo} />
            </Col>
            <Col lg={4} md={6} xs={6} className='mt-lg-0 mt-5'>
              <img alt='Top Workplaces 2025 logo' className='awardLogo' src={topWorkplaceLogo} />
            </Col>
            <Col lg={4} md={6} xs={6} className='mt-lg-5 mt-5 pb-lg-5'>
              <img alt='Forbes Most Trusted Companies 2025 logo' className='awardLogo' src={forbesMostTrustedLogo} />
            </Col>
            <Col lg={4} md={6} xs={6} className='mt-lg-5 mt-5 pb-lg-5'>
              <img alt='Forbes Best Companies 2025 logo' className='awardLogo' src={forbesBestCompaniesLogo} />
            </Col>
            <Col lg={4} md={6} xs={6} className='mt-lg-5 mt-5 pb-lg-5'>
              <img alt='Vets Index 5 Star Employee 2025 logo' className='awardLogo' src={vetsIndex2025Logo} />
            </Col>
          </Row>
        </div>
      </Container>
      </div>
      <div className='navigationArrows'>
        <div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/fy2025-highlights');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[2].classList.add('active');
              document.getElementsByClassName('underline')[2].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div ref={rightArrowRef} className='arrowContainer rightArrow'
        onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/our-approach');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[4].classList.add('active');
              document.getElementsByClassName('underline')[4].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
      </>
  );
}
